import CookieStorage from '../utils/cookieStorage';
export function authHeader() {
  // return authorization header with jwt token
  const token = CookieStorage.get('access');
  if (token) {
    return `Bearer ${token}`;
  }
}
